import { formatPhoneNumber } from '@strata/helper-functions';
import { ReferralStatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

const getTooltipText = ({ referralStatus, supplierName, supplierPhone }) => {
    if (referralStatus === ReferralStatusIndicator.Statuses.PHARM && supplierName) {
        return supplierPhone
            ? `${supplierName} is servicing this referral and can be contacted at ${formatPhoneNumber(
                  supplierPhone,
              )}.`
            : `${supplierName} is servicing this referral. Phone number may be unavailable.`;
    }
    return undefined;
};

export const RTAReferralStatusIndicator = ({
    referralStatus = undefined,
    supplierName = undefined,
    supplierPhone = undefined,
}) => (
    <ReferralStatusIndicator
        status={referralStatus}
        overrideTooltipText={getTooltipText({ referralStatus, supplierName, supplierPhone })}
    />
);

RTAReferralStatusIndicator.propTypes = {
    referralStatus: PropTypes.oneOf(Object.values(ReferralStatusIndicator.Statuses)),
    supplierName: PropTypes.string,
    supplierPhone: PropTypes.string,
};
